<template>
  <section class="uploadSentencePage">
    <popup v-show="isShowUploadSentence" bread="教材管理,课程管理,设置主题资料,上传句型资料" title="上传句型资料" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadHighFrequencyWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'上传句型资料'">
        <h3 class="group-tit">句型资料</h3>
        <commonUploadSentence ref="ref_commonUploadSentence" :key="timestamp" :max-number="(30-currentNumber)" code="jx" @formChange="commonUploadSentenceChange" />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonUploadSentence from '../components/commonUploadSentence'
import { addSentencePattern } from '@api/courseManagement/api_setThemeData'
// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  components: {
    commonUploadSentence
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadSentence: false,
      commonUploadForm: {}
    }
  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadSentence = true
    }
  },
  created () {

  },
  methods: {
    // 返回
    popup_back () {
      this.isShowUploadSentence = false
      // this.$emit('resetFetchData')
    },
    commonUploadSentenceChange (form) {
      this.commonUploadForm = form
      console.log(this.commonUploadForm)
    },
    saveUploadHighFrequencyWord () {
      if (!this.$refs.ref_commonUploadSentence.validateForm()) {
        this.$message.error('请正确填写信息')
        return false
      }
      const params = []
      for (const item of this.commonUploadForm.sentenceList) {
        params.push({
          sentencePatternName: item.sentencePatternName.trim(),
          cardChartName: item.img[0].paramsFileName,
          cardChartPath: item.img[0].paramsUrl,
          sentencePronunciationName: item.voice[0].paramsFileName,
          sentencePronunciationPath: item.voice[0].paramsUrl,
          isSpeaking: item.isSpeaking,
          teachingThemeId: this.themeRow.id,
          meansType: 6
        })
      }

      addSentencePattern({ list: params }).then(res => {
        this.isShowUploadSentence = false
        this.$emit('resetFetchData')
      })
    }

  }
}
</script>

<style lang='scss'>
.uploadSentencePage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
